// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_p4-0";
export var buttonContainer = "_p4-3";
export var cancelButton = "_p4-4";
export var headerSection = "_p4-6";
export var headerTitle = "_p4-9";
export var messageSideLeft = "_p4-1";
export var messageSideRight = "_p4-2";
export var orderNumberContainer = "_p4-7";
export var orderNumberLabel = "_p4-8";
export var submitButton = "_p4-5";